import {Component, Directive, Module} from 'app/decorators';


@Module({
    name: "app.directives.uiSelectHelpers",
})
@Directive('set-focus', function ($parse, $timeout) {
    "ngInject";

    // This is widget designed specifically for ui-select
    return {
        link: {
            post: function(scope, element, attrs){
                attrs.$observe('setFocus', function (value) {
                    value = $parse(value)(scope);
                    if (value) {
                        $timeout(function() {
                            let controller = element.controller('uiSelect');
                            if (controller) {
                                controller.focusser[0].focus();
                            }
                        })
                    }
                })

            }
        }
    }
})
@Directive('allow-remove', function ($timeout) {
    "ngInject";

    return {
        restrict: 'A',
        require: '^uiSelect',
        link: function(scope, element, attrs, $select) {
            element.on('keydown', removeHandler);
            $select.focusser.bind("keyup input", removeHandler);

            function removeValue($event) {
                if ($select.search) {
                    return;
                }
                if ($event.which == 8 || $event.which == 46) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    clear($event);
                }
            }

            function clear() {
                $select.select(null);
                $select.close();

                scope.$apply(function(){

                    if ($select.onRemoveCallback) {
                        $select.onRemoveCallback(scope, {});
                    }

                });
            };

            function removeHandler ($event) {
                removeValue($event);
            }

            scope.$on('$onDestroy', function () {
                element.off('keydown', removeHandler);
                $select.focusser.off('keyup input', removeHandler);
            })

        }
    };
})
@Directive('prevent-animations', function ($animate) {
    "ngInject"
    return {
        restrict: 'A',
        replace: true,
        link: function($scope, $element, $attrs, vm) {
            // Disable $animate for this element
            $animate.enabled($element, false);
        }
    }
})
export class C {}



// WEBPACK FOOTER //
// ./src/app/directives/ui.select.helpers.js